// Clipurile din cardurile de categorie (Operandi Vision, 13–14.10.2026).
// Se încarcă și pornesc doar când cardul e pe ecran și se opresc când iese.
// Pornesc după încărcarea paginii, ca să nu concureze cu bannerul principal (LCP).
// După prima glisare, următoarele 2 clipuri se descarcă în avans.
// Sub clip stă primul lui cadru, deci trecerea nu se vede.
// Fără clip pentru cine are mișcarea redusă sau economizorul de date pornit: rămâne imaginea.
(() => {
  if (window.__collectionCardVideo) return;
  window.__collectionCardVideo = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  if (reduceMotion || saveData || !('IntersectionObserver' in window)) return;

  const AHEAD = 2;

  const load = (video) => {
    if (video.src) return;
    video.muted = true;
    video.preload = 'auto';
    video.src = video.dataset.src;
  };

  const warmNext = (video) => {
    const section = video.closest('.shopify-section') || document;
    const all = [...section.querySelectorAll('video.collection-card__video')];
    const i = all.indexOf(video);
    all.slice(i + 1, i + 1 + AHEAD).forEach(load);
  };

  let interacted = false;
  const visible = new Set();

  const play = (video) => {
    load(video);
    const attempt = video.play();
    if (attempt) attempt.catch(() => {});
    if (interacted) warmNext(video);
  };

  const onInteract = (event) => {
    if (interacted || !event.target.closest || !event.target.closest('collection-list, .swipe-mobile, .collection-list')) return;
    interacted = true;
    visible.forEach(warmNext);
  };
  ['touchstart', 'pointerdown', 'wheel', 'scroll'].forEach((type) =>
    document.addEventListener(type, onInteract, { passive: true, capture: true })
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          visible.add(entry.target);
          play(entry.target);
        } else {
          visible.delete(entry.target);
          if (!entry.target.paused) entry.target.pause();
        }
      });
    },
    { rootMargin: '150px 0px', threshold: 0.2 }
  );

  const scan = () => {
    document.querySelectorAll('video.collection-card__video:not([data-observed])').forEach((video) => {
      video.dataset.observed = '';
      video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
      observer.observe(video);
    });
  };

  const start = () => ('requestIdleCallback' in window ? requestIdleCallback(scan, { timeout: 1500 }) : setTimeout(scan, 300));
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
  document.addEventListener('shopify:section:load', scan);
})();
